module.exports = "pegasus_template/assets/twitter.png";